import Icon from '../../../components/AppIcon';

const ProfileCompletionCard = ({ completion, userType }) => {
  const tasks = userType === 'provider' ? [
    { id: 1, label: 'Add profile photo', completed: true, icon: 'User' },
    { id: 2, label: 'Complete skills section', completed: true, icon: 'Award' },
    { id: 3, label: 'Upload portfolio images', completed: false, icon: 'Image' },
    { id: 4, label: 'Get verified', completed: false, icon: 'CheckCircle' },
    { id: 5, label: 'Add work experience', completed: true, icon: 'Briefcase' }
  ] : [
    { id: 1, label: 'Add profile photo', completed: true, icon: 'User' },
    { id: 2, label: 'Verify email address', completed: true, icon: 'Mail' },
    { id: 3, label: 'Add payment method', completed: false, icon: 'CreditCard' },
    { id: 4, label: 'Complete company profile', completed: false, icon: 'Building' },
    { id: 5, label: 'Post first job', completed: true, icon: 'PlusCircle' }
  ];

  const completedTasks = tasks?.filter(task => task?.completed)?.length;
  const totalTasks = tasks?.length;

  return (
    <div className="bg-card rounded-md p-2.5 md:p-6 shadow-warm">
      <div className="flex items-center justify-between mb-2 md:mb-6">
        <h2 className="text-sm md:text-xl font-heading font-semibold text-foreground">
          Profile Completion
        </h2>
        <span className="text-xl md:text-3xl font-heading font-bold text-primary">
          {completion}%
        </span>
      </div>
      <div className="mb-2 md:mb-6">
        <div className="h-1.5 md:h-3 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary transition-smooth"
            style={{ width: `${completion}%` }}
          />
        </div>
        <p className="text-[10px] md:text-sm text-muted-foreground mt-1 md:mt-2">
          {completedTasks} of {totalTasks} tasks completed
        </p>
      </div>
      <div className="space-y-1.5 md:space-y-3">
        {tasks?.map((task) => (
          <div
            key={task?.id}
            className={`flex items-center gap-2 md:gap-3 p-1.5 md:p-3 rounded-md transition-smooth ${
              task?.completed ? 'bg-success/10' : 'bg-muted hover:bg-muted/80'
            }`}
          >
            <div className={`w-6 h-6 md:w-10 md:h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
              task?.completed ? 'bg-success text-success-foreground' : 'bg-background text-muted-foreground'
            }`}>
              <Icon name={task?.completed ? 'Check' : task?.icon} size={12} className="md:w-5 md:h-5" />
            </div>
            <span className={`text-xs md:text-base font-medium ${
              task?.completed ? 'text-success line-through' : 'text-foreground'
            }`}>
              {task?.label}
            </span>
          </div>
        ))}
      </div>
      {completion < 100 && (
        <button className="w-full mt-2 md:mt-6 px-3 py-2 md:px-4 md:py-3 rounded-md bg-primary text-primary-foreground text-xs md:text-base font-medium hover:opacity-90 transition-smooth">
          Complete Profile
        </button>
      )}
    </div>
  );
};

export default ProfileCompletionCard;